// =========================================================
// * Vuetify Material Dashboard PRO - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import draggable from 'vuedraggable'
import VueResource from 'vue-resource'
import VueSignaturePad from 'vue-signature-pad'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import vuetify from './plugins/vuetify'
import './plugins/vuetify-money.js'
import i18n from './i18n'
import { VueMaskDirective } from 'v-mask'
import css from './styles/variables.json'
import './styles/styles.scss'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { Calendar, DatePicker } from 'v-calendar'
import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib' //Globally import VTextField
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
import firebaseMessaging from './firebase'
import VEmojiPicker from 'v-emoji-picker'

Vue.use(VEmojiPicker)

Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdi',
})

Vue.component('DragDiv', draggable)

Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, {
  locale: i18n.locale,
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true,
})

Vue.use(VueSignaturePad)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
Vue.component('calendar', Calendar)
Vue.component('date-picker', DatePicker)

Vue.prototype.$customStyle = css
Vue.directive('mask', VueMaskDirective)
Vue.config.productionTip = false

Vue.$globalEvent = new Vue()

Vue.use(VueResource)

const options = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 3,
  newestOnTop: true,
  position: 'top-right',
  timeout: 3000,
  pauseOnFocusLoss: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: false,
  icon: true,
}
Vue.prototype.$messaging = firebaseMessaging

Vue.use(Toast, options)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  mounted() {
    Vue.$globalEvent.$on('httpError', (item) => {
      if (item.url.includes('listOpenCalled')) return
      if (item.body && item.body.message) {
        this.$toast.error(this.$t(item.body.message))
      } else if (item.body && item.body.content) {
        if (item.body.content.requireAuthenticate) {
          localStorage.removeItem('institution')
          localStorage.removeItem('token')
          localStorage.removeItem('expires')
          localStorage.removeItem('user')
          this.$router.push('/auth')
        }
        if (item.body.content.length > 0)
          this.$toast.error(this.$t(item.body.content))
      }
      // else if (item.status != 403) this.$toast.error('Ocorreu um erro!')
    })
  },
  render: (h) => h(App),
}).$mount('#app')
